import { computeCoordinateExtents } from "utils/math/computeCoordinateExtents";
import type { BuildScaledRoute } from "./types";

export const buildScaledRoute: BuildScaledRoute = ({
  row,
  meters,
  response,
  pageIndex,
  sibling,
}) => {
  const nodes = row.nodes.map((node) => ({
    id: node.id,
    x: node.x,
    y: node.y,
  }));
  return {
    route_type_id: response.routeTypeId,
    id: String(response.id),
    name: row.name,
    page: pageIndex,
    breaker: row.breaker,
    cable_type: response.routeTypeName,
    // Status and LV belong to the cable type, so the route takes its group's.
    cable_type_status: sibling?.cable_type_status ?? "confident",
    lv_position: sibling?.lv_position ?? "",
    lvMatch: sibling?.lvMatch,
    note: "",
    distance_px: 0,
    meters,
    nodes,
    edges: row.edges.map((edge) => ({ from: edge.from, to: edge.to })),
    creation_source: "manual",
    coordinateExtents: computeCoordinateExtents(nodes),
  };
};
